import styles from "./Targeting.module.scss"
import Checkbox from "../../../../../components/common/Checkbox/Checkbox"

const Targeting = ({ checkboxState, handleCheckboxChange }) => {  

  return (
    <div>
      <div className={styles["heading"]}>Targeting</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <div>Select preferred targeting option</div>

          <div className="px-3">
            <div className="d-flex gap-2">
              <div className="mt-1">
                <Checkbox name="automatic" checked={checkboxState.automatic} onChange={handleCheckboxChange} />
              </div>
              <div>
                <div>Automatic targeting</div>
                <div>(Maelano will suggest keywords and products that are similar to the product in your add and optimize bid proces)</div>
              </div>
            </div>
            <div className="d-flex gap-2">
              <div className="mt-1">
                <Checkbox name="manual" checked={checkboxState.manual} onChange={handleCheckboxChange} />
              </div>
              <div>
                <div>Manual targeting</div>
                <div>(You can choose keywords and products to target customer searches and manually set custom bids)</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Targeting
